import { render, staticRenderFns } from "./WebTabDetail.vue?vue&type=template&id=3ee6babc"
import script from "./WebTabDetail.vue?vue&type=script&lang=js"
export * from "./WebTabDetail.vue?vue&type=script&lang=js"
import style0 from "./WebTabDetail.vue?vue&type=style&index=0&id=3ee6babc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports